import { KeyValueModel } from "model/api";
import { EnumStatusSalao } from "model/enums/enum-status-salao";

export const TpStatusSalaoMock: KeyValueModel[] = [
    new KeyValueModel(EnumStatusSalao.ATIVO, "Ativo"),
    new KeyValueModel(EnumStatusSalao.INATIVO, "Inativo"),
];
